interface BIM_TYPEProp {
  THREE_DIMENSIONAL: string,
  TWO_DIMENSIONAL: string,
}
export const BIM_TYPE: BIM_TYPEProp = {
  THREE_DIMENSIONAL: "3D",
  TWO_DIMENSIONAL: "2D",
};
